import { useEffect, useState } from "react"
import { createPortal } from "react-dom"
import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const TOASTER_CONTAINER_ID = "sonner-toaster-portal"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()
  const [container, setContainer] = useState<HTMLElement | null>(null)

  useEffect(() => {
    let el = document.getElementById(TOASTER_CONTAINER_ID)
    if (!el) {
      el = document.createElement("div")
      el.id = TOASTER_CONTAINER_ID
      el.style.cssText = "position:fixed;inset:0;z-index:2147483647;pointer-events:none;"
      document.body.appendChild(el)
    }
    // Garantir que o container seja sempre o último filho do body (acima de modais Radix)
    document.body.appendChild(el)
    setContainer(el)
    return () => {
      el?.remove()
      setContainer(null)
    }
  }, [])

  const sonnerContent = (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        style: { pointerEvents: "auto" },
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  )

  if (!container) return null

  return createPortal(sonnerContent, container)
}

export { Toaster }
